import React from 'react';
import { Box, Typography } from '@mui/material';
import About from './Images/About.jpg';
import { useTranslation } from 'react-i18next';

const HeroSection = () => {
  const { t, i18n } = useTranslation();

  const isRTL = i18n.dir() === 'rtl';
  const fontFamily = isRTL
    ? "'Tajawal', Arial, sans-serif"
    : "Arial, Helvetica, sans-serif";

  return (
    <Box
      sx={{
        position: 'relative',
        height: '85vh',
        backgroundImage: `url(${About})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        color: 'white',
        display: 'flex',
        alignItems: 'center',
        padding: { xs: 2, md: 8 },
        fontFamily,
        direction: isRTL ? 'rtl' : 'ltr',
      }}
    >
      {/* Overlay */}
      <Box
        sx={{
          position: 'absolute',
          width: '100%',
          height: '100%',
          top: 0,
          left: 0,
          bgcolor: 'rgba(0, 0, 0, 0.47)',
          zIndex: 1,
        }}
      />

      {/* Content */}
      <Box sx={{ position: 'relative', zIndex: 2, maxWidth: 700 }}>
        <Typography
        fontFamily={fontFamily}
          variant="subtitle1"
          sx={{
            textTransform: 'uppercase',
            letterSpacing: 1,
            mb: 2,
          }}
        >
          {t("title")}
        </Typography>

        <Typography
          variant="h2"
          component="h1"
           fontFamily={fontFamily}
          sx={{
            fontWeight: 300,
            lineHeight: 1.2,
          }}
        >
          {t("titleh")}
        </Typography>

        <Typography
         fontFamily={fontFamily}
          variant="h5"
          component="h1"
         sx={{
            fontWeight: 300,
            lineHeight: 1.2,
          }}
        >
          {t("titleh2")}
        </Typography>
      </Box>
    </Box>
  );
};

export default HeroSection;
